import { TrendItem } from "@/config/types/trend";
import BtnGroup from "@/containers/trend-audit/detail-components/BtnGroup";
import { transTrendTime } from "@/utils/utils";
import { Popup, SafeArea } from "antd-mobile";
import { Link } from "react-router-dom";
import { mutate } from "swr";
import Auther from "./Auther";
// import TrendJob from "@/containers/trend-audit/components/TrendJob";
import classNames from "classnames";

interface ShowMoreContentPopupProps {
  visible: boolean;
  data: TrendItem;
  theme: "light" | "dark";
  isAuditPage?: boolean; // 是否是审核页
  onClose: () => void;
}

const ShowMoreContentPopup = ({
  visible,
  data,
  theme,
  isAuditPage,
  onClose,
}: ShowMoreContentPopupProps) => {
  return (
    <Popup className="all-content-popup" visible={visible} closeOnMaskClick onClose={onClose}>
      <Auther theme={theme} isAuditPage={isAuditPage} data={data} />
      {data.title && (
        <div className="trend-title" dangerouslySetInnerHTML={{ __html: data.title }}></div>
      )}
      <div className="trend-content-container">
        <div className="trend-content" dangerouslySetInnerHTML={{ __html: data.content }}></div>
        {Array.isArray(data.topics) && data.topics.length && (
          <div className="trend-topic">
            {data.topics.map((item) => (
              <Link
                key={item.paramId}
                className={classNames("trend-topic-item", { sensi: item.sensi === "true" })}
                onClick={(e: any) => e.stopPropagation()}
                to="/"
                // to={`${_route.TOPIC_TREND}?id=${item.paramId}`}
              >
                #{item.paramName}
              </Link>
            ))}
          </div>
        )}
        {/* 关联职位 */}
        {/* <TrendJob /> */}
        <div className="trend-publish-info">
          发布于{transTrendTime(data.createTime || "")} {data.city || data.province}
        </div>
      </div>
      {isAuditPage && (
        <BtnGroup
          data={data}
          onSuccess={() => {
            mutate(`trend-audit-detail-${data.trendsId}`);
            onClose();
          }}
        />
      )}
      <SafeArea position="bottom" />
    </Popup>
  );
};
export default ShowMoreContentPopup;
